export var DeliveryLocation;
(function (DeliveryLocation) {
    DeliveryLocation["HOME"] = "home";
    DeliveryLocation["DEALER"] = "dealer";
})(DeliveryLocation || (DeliveryLocation = {}));
export const MAX_ADDRESS_LENGTH = 30;
export const DEFAULT_EXTERNAL_ID = 'no-external-id-defined';
export const DEFAULT_DEALER_ID = 'dealer-id';
export const DEFAULT_DESTINATION_CODE = '0000000';
export const SHIPMENT_LABEL_MAX_LENGTH = 30;
export const SHIPMENT_LABEL_DEFAULT_VALUE = 'undefined';
